/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var HandThumbDownIcon24Solid = forwardRef('HandThumbDownIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M13.05 21.777A2.126 2.126 0 0 1 9 20.874V16H4.46a3 3 0 0 1-2.891-3.801l1.711-6.176A4.125 4.125 0 0 1 7.254 3H16.5v12.24c-.334.188-.61.478-.78.84l-2.67 5.697Z" }),
        React.createElement("path", { d: "M20.25 15A1.75 1.75 0 0 0 22 13.25v-8.5A1.75 1.75 0 0 0 20.25 3H18v12h2.25Z" })));
});
